import { Injectable } from "@angular/core";
import { ReplaySubject, Observable } from "rxjs";
import { UserModel } from "../models/user";

@Injectable({
  providedIn: "root",
})
export class MockAuthService {
  private _user: ReplaySubject<UserModel> = new ReplaySubject<UserModel>(1);

  get user$(): Observable<UserModel> {
    return this._user.asObservable();
  }

  constructor() {
    this.loadMockUser();
  }

  private loadMockUser() {
    const mockUser: UserModel = {
      id: "mock-user-123",
      email: "test@example.com",
      name: "Test",
      lastName: "User",
      username: "testuser",
      fullName: "Test User",
    };
    this._user.next(mockUser);
  }

  public loadUser() {
    this.loadMockUser();
  }

  mapUser(user: any) {
    this._user.next(user);
  }

  public getRoles(): string[] {
    return [
      'read_chatbot',
      'run_chatbot',
      'write_chatbot',
      'read_usermanagement',
      'write_usermanagement',
      'write_users',
      'read_systemparams',
      'write_systemparams',
    ];
  }

  private extractResourceFromRole(role: string): string {
    const parts = role.split('_');
    return parts.length > 1 ? parts[1] : '';
  }

  public hasAccessToResource(resourceId: string): boolean {
    const roles = this.getRoles();
    const resources = roles.map(role => this.extractResourceFromRole(role));
    
    const normalizedId = resourceId.toLowerCase().replaceAll('-', '').split('/')[0];
    
    return resources.some(resource => {
      const normalizedResource = resource.toLowerCase().replaceAll('-', '');
      return normalizedResource === normalizedId;
    });
  }

  public hasAnyPermission(requiredPermissions: string[]): boolean {
    const userRoles = this.getRoles();
    
    return requiredPermissions.some(required => {
      if (userRoles.includes(required)) {
        return true;
      }
      
      const parts = required.split('_');
      if (parts.length < 2) return false;
      
      const level = parts[0];
      const resource = parts.slice(1).join('_');
      
      if (level === 'read') {
        const runRole = `run_${resource}`;
        const writeRole = `write_${resource}`;
        return userRoles.includes(runRole) || userRoles.includes(writeRole);
      } else if (level === 'run') {
        const writeRole = `write_${resource}`;
        return userRoles.includes(writeRole);
      }
      
      return false;
    });
  }
}
